import { render, staticRenderFns } from "./NewDPostContentPreview.vue?vue&type=template&id=490b80a3&scoped=true&"
import script from "./NewDPostContentPreview.vue?vue&type=script&lang=js&"
export * from "./NewDPostContentPreview.vue?vue&type=script&lang=js&"
import style0 from "./NewDPostContentPreview.vue?vue&type=style&index=0&id=490b80a3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "490b80a3",
  null
  
)

export default component.exports